import React from 'react';

import styled from 'styled-components';

import { ILocation } from '@rbi-ctg/frontend';
import { brand, getApiKey } from 'utils/environment';
import { GOOGLE_MAPS_API_BASE_URL } from 'utils/geolocation/utils';

interface IStaticMap {
  position: ILocation;
  imgSize?: {
    width: number;
    height: number;
  };
  zoom?: number;
  scale?: number;
  icon?: string;
}

const StaticMapImg = styled.img`
  width: 100%;
  object-fit: cover;
`;

const StaticMap: React.FC<IStaticMap> = ({
  position,
  imgSize: { width, height } = {
    // 640px max on static maps
    width: 600,
    // 640px max on static maps
    height: 170,
  },
  zoom = 12,
  scale = 2,
  icon = null,
}) => {
  const basepath =
    document.querySelector('meta[property="og:url"]')?.getAttribute('content') ||
    window.location.origin;
  const brandicon = `${brand()}/location-pin-active.png`;
  const iconpath = icon || `${basepath}/assets/${brandicon}`;

  const queryParams = {
    center: `${position.lat},${position.lng}`,
    zoom,
    size: `${width}x${height}`,
    scale,
    markers: `icon:${iconpath}|anchor:center|${position.lat},${position.lng}`,
    key: getApiKey('googleMapsWeb') || getApiKey('googleMaps'),
  };
  const path = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return (
    /* Non-premium Google maps account have a max static map size of 640x640*/
    /* https://developers.google.com/maps/documentation/maps-static/dev-guide#Imagesizes*/
    <StaticMapImg
      data-testid="staticmap"
      src={`${GOOGLE_MAPS_API_BASE_URL}/staticmap?${path}`}
      alt={`static map for ${position.lat}, ${position.lng}`}
    />
  );
};

export default StaticMap;
